import { useQuery } from "@tanstack/react-query";
import { BRIEF_PAYMENT_FACETS_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export const useGetBriefPaymentFacets = () => {
  const { data, isFetching } = useQuery({
    queryKey: [BRIEF_PAYMENT_FACETS_QUERY_KEY],
    queryFn: () => BriefService.getBriefPaymentFacets(),
  });

  return {
    facets: data?.data,
    isFetching,
  };
};
